export default "assets/images/logo-788943a2.png";